<template>
  <div class="z-10 w-full h-full flex flex-row grid" :class="{ thick: thick, background: background, curved: curved }">
    <transition name="fade">
      <div v-if="showColumns > 0" class="flex flex-col w-1/3 h-full">
        <div class="e-top" :class="{ scalar: scalarMode }" />
        <div class="e-bottom" :class="{ scalar: scalarMode }">
          <transition name="fade">
            <div v-if="showWords > 0 && showWords < 4" class="w-full h-full flex justify-center items-center">
              <h1>Experimenting</h1>
            </div>
          </transition>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div v-if="showColumns > 1" class="flex flex-col w-1/3 h-full">
        <div class="e-top" :class="{ scalar: scalarMode }">
          <transition name="fade">
            <div v-if="showWords > 1 && showWords < 5" class="w-full h-full flex justify-center items-center">
              <h1>Experiencing</h1>
            </div>
          </transition>
        </div>
        <div class="e-bottom" :class="{ scalar: scalarMode }" />
      </div>
    </transition>
    <transition name="fade">
      <div v-if="showColumns > 2" class="flex flex-col w-1/3 h-full">
        <div class="r-top" :class="{ scalar: scalarMode }" />
        <div class="r-bottom" :class="{ scalar: scalarMode }">
          <div class="leg" />
          <transition name="fade">
            <div v-if="showWords > 2 && showWords < 6" class="w-full h-full flex justify-center items-center">
              <h1>Reflecting</h1>
            </div>
          </transition>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'GridSix',

  props: [
    'scalarMode',
    'showColumns',
    'showWords',
    'thick',
    'background',
    'curved'
  ]
}
</script>

<style scoped lang="stylus">
.grid {
  background-color: transparent;
  transition: background-color .65s ease-in-out;
}

.grid.background {
  background-color: white;
}

.e-top {
  position: relative;
  background: transparent;
  border-top: 1px solid black;
  border-bottom: 1px solid black;
  border-left: 1px solid black;
  width: 100%;
  height: calc(50% - 32px);
  transition: border-width .65s ease-in-out, height .65s ease-in-out;

}

.e-top.scalar {
  height: 50%;
}

.thick .e-top {
  border-top-width: 5px;
  border-bottom-width: 5px;
  border-left-width: 5px;
}

.e-bottom {
  position: relative;
  background: transparent;
  border-bottom: 1px solid black;
  border-left: 1px solid black;
  width: 100%;
  height: calc(50% + 32px);
  transition: border-width .65s ease-in-out, height .65s ease-in-out;
}

.e-bottom.scalar {
  height: 50%;
}

.thick .e-bottom {
  border-left-width: 5px;
  border-bottom-width: 5px;
}

.r-top {
  position: relative;
  background: transparent;
  border-top: 1px solid black;
  border-right: 1px solid black;
  border-bottom: 1px solid black;
  border-left: 1px solid black;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;  
  width: 100%;
  height: calc(50% - 32px);
  transition: border-width .65s ease-in-out, height .65s ease-in-out, border-radius .65s ease-in-out;
}

.r-top.scalar {
  height: 50%;
}

.curved .r-top {
  border-top-right-radius: 50px;
  border-bottom-right-radius: 50px;
}

.thick .r-top {
  border-top-width: 5px;
  border-right-width: 5px;
  border-bottom-width: 5px;
  border-left-width: 5px;
}

.r-bottom {
  position: relative;
  background: transparent;
  border-left: 1px solid black;
  width: calc(100% - 87px);
  height: calc(50% + 32px);
  transition: border-width .65s ease-in-out, width .65s ease-in-out, height .65s ease-in-out;
}

.r-bottom.scalar {
  width: 66%;
  height: 50%;
}

.r-bottom .leg {
  position: absolute;
  top: 0;
  left: 0;  
  width: 100%;
  height: 100%;
  transform-origin: top right;
  transform: skew(0deg, 0deg);
  transition: border-width .65s ease-in-out, transform .65s ease-in-out,;
  border-right: 1px solid black;
}

.curved .r-bottom .leg {
  transform: skew(20deg, 0deg);  
}

.thick .r-bottom {
  border-left-width: 5px;
}

.thick .r-bottom .leg {
  border-right: 5px solid black;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .65s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
